import script from "./DownloadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadModal.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadModal.vue?vue&type=style&index=0&id=22c690e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c690e4"]])

export default __exports__